// components/modals/app-modals/onboarding/steps/OnboardingProfessionalStep.jsx

import { useTranslation } from 'react-i18next';

const OnboardingProfessionalStep = ({ formData, onChange, toggleArrayValue }) => {
  const { t } = useTranslation();

  return (
    <>
      {/* 🧭 Intro del pas */}
      <div className="app-modal-step-intro">
        <h3>
          {t(
            'onboarding_professional_title',
            'Your background'
          )}
        </h3>
        <p className="app-modal-text-muted">
          {t(
            'onboarding_professional_intro',
            'Tell us about your relationship with voice. Select all options that apply.'
          )}
        </p>
      </div>

      {/* 🔹 PROFESSION (single) */}
      <div className="app-modal-section">
        <p className="app-modal-label">
          {t('profession_question', 'What is your main profession?')}
        </p>

        <select
          name="profession"
          value={formData.profession}
          onChange={onChange}
          className="app-input"
        >
          <option value="">{t('select_profession')}</option>
          <option value="SLP">{t('slp')}</option>
          <option value="ENT">{t('ent')}</option>
          <option value="other_medical_doctor">{t('other_medical_doctor', 'Other medical doctor')}</option>
          <option value="vocal_coach">{t('vocal_coach')}</option>
          <option value="singing_teacher">{t('singing_teacher')}</option>
          <option value="singer">{t('singer', 'Singer')}</option>
          <option value="musician">{t('musician', 'Musician')}</option>
          <option value="engineer">{t('engineer', 'Engineer')}</option>
          <option value="technologist">{t('technologist', 'Technologist')}</option>
          <option value="linguist">{t('linguist', 'Linguist')}</option>
          <option value="other">{t('other')}</option>
        </select>
      </div>

      {/* 🧑‍⚕️ FIELD / BACKGROUND */}
      <div className="app-modal-section">
        <p className="app-modal-label">
          {t(
            'background_question',
            'What best describes your field?'
          )}
        </p>
        {[
          { value: 'speech_language_pathology', label: t('speech_language_pathology', 'Speech Language Pathology') },
          { value: 'medicine', label: t('medicine', 'Medicine') },
          { value: 'otolaryngology', label: t('otolaryngology', 'ENT / Otolaringology') },
          { value: 'music', label: t('music', 'Music') },
          { value: 'vocal_pedagogy', label: t('vocal_pedagogy', 'Vocal pedagogy') },
          { value: 'engineering', label: t('engineering', 'Engineering') },
          { value: 'technology', label: t('technology', 'Technology') },
          { value: 'linguistics', label: t('linguistics', 'Linguistics') },
          { value: 'neuroscience', label: t('neuroscience', 'Neuroscience') },
          { value: 'education', label: t('education', 'Education') },
          { value: 'performing_arts', label: t('performing_arts', 'Performing Arts') },
          { value: 'research', label: t('research', 'Research') },
          { value: 'other', label: t('other', 'Other') }
        ].map(item => (
          <label key={item.value} className="checkbox-container">
            <input
              type="checkbox"
              checked={formData.background.includes(item.value)}
              onChange={() =>
                toggleArrayValue('background', item.value)
              }
            />
            {item.label}
          </label>
        ))}
      </div>

      {/* 🧑‍🏫 PROFESSIONAL ROLES */}
      <div className="app-modal-section">
        <p className="app-modal-label">
          {t(
            'roles_question',
            'Which roles do you currently have?'
          )}
        </p>
        {[
          { value: 'student', label: t('student', 'Student') },
          { value: 'teacher', label: t('teacher', 'Teacher / Lecturer') },
          { value: 'researcher', label: t('researcher', 'Researcher') },
          { value: 'clinician', label: t('clinician', 'Clinician') },
          { value: 'artist', label: t('artist', 'Artist') },
          { value: 'developer', label: t('developer', 'Developer') },
          { value: 'other', label: t('other', 'Other') }
        ].map(role => (
          <label key={role.value} className="checkbox-container">
            <input
              type="checkbox"
              checked={formData.professionalRoles.includes(role.value)}
              onChange={() =>
                toggleArrayValue('professionalRoles', role.value)
              }
            />
            {role.label}
          </label>
        ))}

      </div>

    </>
  );
};

export default OnboardingProfessionalStep;
